/*
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: enbo.zhou@dsicm.com
 * @Date: 2021-03-18 15:30:15
 * @LastEditors: enbo.zhou@dsicm.com
 * @LastEditTime: 2021-05-08 17:02:24
 * @FilePath: /dsicm-admin-web/src/views/Organization/conmon/platforminform.js
 */
export default{
  data(){
    return{
      homeTableConfig:[
          {
              label: '序号',
              align: 'center',
              fixed: 'left',
              render: (h, scope) => {
                  return <span slot="reference">{scope.$index * 1 + 1}</span>
              },
          },
          { 
              label: '平台编号', 
              align: 'center', 
              prop: 'code' 
          },
          {
              label: '平台医院名称',
              align: 'center',
              prop: 'name',
          },
          { 
              label: '平台医院简称', 
              align: 'center', 
              prop: 'shortName' 
          },
          {
              label: '医院类型',
              align: 'center',
              prop: 'orgTypeName',
          },
          { 
              label: '业务分类', 
              align: 'center', 
              prop: 'businessTypeName' 
          },
          {
              label: '医院等级',
              align: 'center',
              prop: 'levelName',
          },
          {
              label: '依托实体医院',
              align: 'center',
              prop: 'hospitalName',
          },
          {
              label: '状态',
              align: 'center',
              // prop: 'disabled',
              render: (h, scope) => {
                return <span slot="reference">{scope.row.disabled ? '已禁用' : '已启用'}</span>
              },
          },
          {
              label: '修改人',
              align: 'center',
              prop: 'updateUserId',
          },
          {
              label: '修改时间',
              align: 'center',
              prop: 'updateTime',
          },
          {
              label: '医院说明',
              align: 'center',
              render: (h, scope) => {
                  return (
                    <div>
                      {/* <el-popover popper-class="popper" trigger="hover">
                        <div slot="reference" style="height: 46px; display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 2; overflow: hidden;">{scope.row.description}</div>
                        <div style="height:100px">
                          <el-scrollbar style="height: 100%" wrap-style="overflow-x:hidden;">{scope.row.description}</el-scrollbar>
                        </div>
                      </el-popover> */}
                      {scope.row.description}
                    </div>
                  )
              },
          },
          {
              label: '操作',
              align: 'center',
              fixed: 'right',
              width: '200px',
              render: (h, scope) => {
                return (
                  <div>
                    <el-button size="mini" type="text" onClick={() => this.hometHandelDetails(scope)}>
                      查看详情
                    </el-button>
                    <el-button size="mini" type="text" onClick={() => this.$router.push({path:'/Organization/department',query:{id:scope.row.id,type:'platform'}})}>
                      科室
                    </el-button>
                    <el-button size="mini" type="text" onClick={() => this.$router.push({path:'/Organization/medicalinfo',query:{id:scope.row.hospitalId}})}>
                      医护
                    </el-button>
                    <el-button size="mini" type="text" onClick={() => this.disableHandel(scope)}>
                      { scope.row.disabled ? '启用' : '禁用'}
                    </el-button>
                  </div>
                )
              },
          },

      ],

    }
  }
}

